import React from 'react';
import dl1 from '../../assets/results/dl-1.png';
import dl2 from '../../assets/results/dl-2.png';
import divider from '../../assets/divider-img.png';

const DeliveringResults = () => {
  return (
    <div className="home-services">
      <div className="container">
        <div className="section-top service-explore-top">
          <h2>Delivering Results</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            At Quantome, we understand that in the world of trading, results
            speak louder than words. Our commitment to excellence isn't just
            theoretical—it translates into tangible outcomes for our clients.
          </p>
        </div>
        <div className="delivering-results-wrapper">
          <img src={dl1} alt="delivering results" />
          <img src={dl2} alt="delivering results" />
        </div>
      </div>
    </div>
  );
};

export default DeliveringResults;
